/**
 * Routing Codes API Service
 * Handles routing code operations.
 *
 * Base URL: /api (apiFetch adds /api prefix)
 */
import { useCallback, useMemo } from "react";
import { useApi } from "@/hooks/use-api";
import type { RoutingCodeDto } from "@/types/api/routing-codes";

const ROUTING_CODES_BASE = "/routingcodes";

/**
 * Hook providing routing code API operations with authentication
 */
export function useRoutingCodesApi() {
    const api = useApi();

    /**
     * List all routing codes for the authenticated user's client
     * GET /api/routingcodes
     */
    const getRoutingCodes = useCallback(async (): Promise<RoutingCodeDto[]> => {
        return api.get<RoutingCodeDto[]>(ROUTING_CODES_BASE);
    }, [api]);

    return useMemo(
        () => ({
            getRoutingCodes,
        }),
        [getRoutingCodes],
    );
}
